import React from "react";
import Icon from "../assets/icons";
import { formatDate } from "../utilz/function";

interface TableColumn {
  header: string;
  accessor: string;
  [key: string]: any;
}

interface TableRow {
  [key: string]: any;
}

interface TableProps {
  columns: TableColumn[];
  data: TableRow[];
  selectedUserId: string | null;
  currentPage?: number | null;
  onPageChange?: number | null;
  onUserClick?: (id: string) => void;
  onEditClick?: (id: string) => void;
  onRemoveClick?: (id: string) => void;
  onDeleteClick?: (id: string) => void;
}

const Table: React.FC<TableProps> = ({
  columns,
  data,
  onUserClick,
  onEditClick,
  onRemoveClick,
  onDeleteClick,
  selectedUserId,
}) => {


  return (
    <div className="overflow-x-auto">
      <table className="table mt-6 w-full min-w-full">
        <thead className="bg-[#F5F5F5] border-b-2 border-[#9D9898] mx-5 h-[48px]">
          <tr className="text-[16px] text-left">
            {columns?.map((column, index) => (
              <th className="font-medium px-5" key={index}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="text-[12px] px-5">
          {data?.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              onClick={() =>
                onUserClick && onUserClick(row["id"] || row["_id"])
              }
              className={`cursor-pointer ${
                selectedUserId === (row["id"] || row["_id"])
                  ? "bg-gray-200"
                  : ""
              }`}
            >
              {columns.map((column, colIndex) => (
                <td
                  key={colIndex}
                  className="h-[72px] text-[#4E4E4E] text-[14px] px-5 border-t border-[#C9C9C9]"
                >
                  {column.accessor === "updatedAt" ||
                  column.accessor === "createdAt" ? (
                    formatDate(row[column.accessor])
                  ) : column.accessor === "profilePhoto" ? (
                    <img
                      src={
                        row[column.accessor] ||
                        `https://ui-avatars.com/api/?name=${
                          row["fullname"] || row["fullName"]
                        }&background=0979A1&color=fff`
                      }
                      className="rounded-full w-[40px] h-[40px]"
                      alt="profile"
                    />
                  ) : column.accessor === "id" || column.accessor === "_id" ? (
                    <div className="flex gap-2">
                      {onUserClick && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onUserClick(row["id"] || row["_id"]);
                          }}
                        >
                          View
                        </button>
                      )}
                      {onEditClick && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onEditClick(row["id"] || row["_id"]);
                          }}
                        >
                          Edit
                        </button>
                      )}
                      {onRemoveClick && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onRemoveClick(row["id"] || row["_id"]);
                          }}
                        >
                          Remove
                        </button>
                      )}
                      {onDeleteClick && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onDeleteClick(row["id"] || row["_id"]);
                          }}
                          className="text-red-400"
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  ) : column.accessor === "phone" && !row[column.accessor] ? (
                    "N/A"
                  ) : column.accessor === "status" ? (
                    <p
                      className="-mt-1 text-center font-normal w-20 rounded-md"
                    
                    >
                      {(row[column.accessor])}
                    </p>
                  ) : (
                    row[column.accessor]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
